export enum PriceFormatterEnum {
  WHOLE_DOLLAR = 'whole_dollar',
  PRICE = 'price',
}

export enum PricingMemberTypeEnum {
  MEMBER = 'member',
  NON_MEMBER = 'non_member',
}
